import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ShoppingCart } from 'lucide-react';
import { Button } from './ui/button';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { path: '/', label: 'Inicio' },
    { path: '/libro', label: 'El Libro' },
    { path: '/tiane', label: 'Tiane' },
    { path: '/logros', label: 'Logros' },
    { path: '/comprar', label: 'Comprar' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-muro-dark/95 backdrop-blur-md shadow-lg border-b border-muro-gray-800'
          : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3 group">
            <div className="text-2xl font-bold">
              <span className="text-gold-gradient">CE</span>
            </div>
            <div className="hidden md:flex flex-col leading-tight">
              <span className="text-muro-gold font-bold text-lg tracking-wider">
                EL MURO
              </span>
              <span className="text-muro-text text-xs tracking-widest">
                ENDLER
              </span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`relative text-sm font-medium tracking-wide transition-colors duration-300 ${
                  isActive(link.path)
                    ? 'text-muro-gold'
                    : 'text-muro-text hover:text-muro-gold'
                }`}
              >
                {link.label}
                {isActive(link.path) && (
                  <span className="absolute -bottom-1 left-0 w-full h-0.5 bg-muro-gold"></span>
                )}
              </Link>
            ))}
          </div>

          {/* CTA Button */}
          <div className="hidden md:flex items-center space-x-4">
            <Link to="/comprar">
              <Button className="btn-gold px-6 py-2 rounded-md flex items-center space-x-2">
                <ShoppingCart className="w-4 h-4" />
                <span>Preventa</span>
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-muro-text hover:text-muro-gold transition-colors p-2"
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? (
              <X className="w-6 h-6" />
            ) : (
              <Menu className="w-6 h-6" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-muro-dark border-t border-muro-gray-800">
          <div className="container mx-auto px-4 py-6 space-y-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block py-3 text-base font-medium transition-colors border-l-4 pl-4 ${
                  isActive(link.path)
                    ? 'text-muro-gold border-muro-gold bg-muro-gray-900'
                    : 'text-muro-text border-transparent hover:text-muro-gold hover:border-muro-gold'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/comprar"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block"
            >
              <Button className="btn-gold w-full py-3 rounded-md flex items-center justify-center space-x-2">
                <ShoppingCart className="w-5 h-5" />
                <span>Preventa del Libro</span>
              </Button>
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
